import { render, staticRenderFns } from "./TabMenuList.vue?vue&type=template&id=6b5d246b&scoped=true&"
import script from "./TabMenuList.vue?vue&type=script&lang=js&"
export * from "./TabMenuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d246b",
  null
  
)

export default component.exports